module.exports = __webpack_public_path__ + "static/resume-83d8f94697415172273ba5f1d25cb84a.pdf";